import React from 'react';
import './footer.css'

import { } from 'react-bootstrap';

export default function (){
    return(
        <div className='footer'>
            <div>
            <strong>Join the Community</strong>
            <br />
            <a href='https://discord.gg/ZDEKXPw'>Chat Now</a>
            </div>

            <div>
            <strong>Twitter</strong>
            <br />
            <a href='https://twitter.com/techie_knights'>Reach Us</a>
            </div>
        </div>
    )
}